<div class="verification">

  @if (resendAccountActivated) {
    <form
      [action]="loginActionUrl"
      method="POST" #accountActivatedForm>
      <input type="hidden" name="authenticity_token" [value]="csrfToken">
      <input type="hidden" name="user[login]" [value]="uuid">
      <se-fe-alert seFeDataType="error">
        This account is already activated.
        <button seFeLink type="submit"
        (click)="signIn()">Sign in using this account</button>
      </se-fe-alert>
    </form>
  }

  @if (unknownError) {
    <se-fe-alert seFeDataType="error">
      There was an unknown error resending the verification email.
      Please return to create account and try again.
    </se-fe-alert>
  }

  @if (resendSuccess) {
    <se-fe-alert seFeDataType="success">
      The verification email was resent.
    </se-fe-alert>
  }

  <header>
    <h3>A verification link has been sent to</h3>
    <p class="subheader">
      {{ email }}
    </p>
  </header>

  <div role="content">

    <div class="form-field">
      <se-fe-button
        seFeDataEmphasis="high"
        seFeDataType="button"
        [seFeDataIsLoading]="submitting"
        [seFeDataFullWidth]="true"
        (click)="resend()">
        Resend Verification Email
      </se-fe-button>

      <se-fe-button
        seFeDataEmphasis="medium"
        seFeDataType="button"
        [seFeDataFullWidth]="true"
        (click)="startOver()">
        Return to Create Account
      </se-fe-button>
    </div>

  </div>
</div>
